module.exports = __webpack_public_path__ + "img/27.e07f9a9c.png";